import assetAttribute from './assetattribute'
import location from './location'
import equipment from './equipment'
import asset from './asset'

import locations from './locations'

const AssetServer = {
    assetAttribute: assetAttribute,
    location: location,
    locations : locations,
    asset: asset,
    equipment: equipment,
};

export default AssetServer;
